import { supabase } from '../supabase';

interface RecommendationError {
  message: string;
}

export async function submitRecommendation(
  category: string,
  recommendation: string,
  userId: number
) {
  try {
    const { data, error } = await supabase
      .from('recommendations')
      .insert({
        category,
        recommendation,
        sender_user_id: userId
      })
      .select('*')
      .single();

    if (error) {
      console.error('Supabase error:', error);
      throw error;
    }

    return { data, error: null };
  } catch (error) {
    const err = error as RecommendationError;
    console.error('Error submitting recommendation:', err);
    return { 
      data: null, 
      error: err.message || 'Failed to submit recommendation'
    };
  }
}